import {InteractiveFormControllerApi, InteractiveResponse} from 'Documents/api';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {InteractiveFilters} from '../ducks/Interactive';
import {InteractiveFormStateDto} from '../models/Interactive';

export const documentsRootUri = '/documents';
const interactiveFormApi = new InteractiveFormControllerApi(undefined, 'api' + documentsRootUri, axiosInstance);

const getInteractiveForms = (
  claims: object,
  interactive?: InteractiveResponse,
  isNewYork?: boolean,
  filter?: InteractiveFilters,
  sort?: Sort
) =>
  withCancellation(cancelToken =>
    interactiveFormApi.getInteractiveFormsUsingGET(
      filter?.description.toString(),
      filter?.category.tag === 'SelectedOption' ? filter?.category.value.toString() : '',
      filter?.formNumber.toString(),
      isNewYork,
      filter?.pageNumber.toString(),
      filter?.pageSize.toString(),
      filter?.product.toString(),
      sort?.column.toString(),
      sort?.direction.toString(),
      filter?.states.tag === 'SelectedOption' ? filter?.states.value.toString() : '',
      undefined,
      filter?.type.tag === 'SelectedOption' ? filter?.type.value.toString() : '',
      getAxiosConfig(cancelToken)
    )
  ).then(handleResponse);

const getInteractiveFormStates = (state: InteractiveFormStateDto) =>
  withCancellation(cancelToken =>
    interactiveFormApi.getInteractiveFormsStatesUsingGET(
      state.fid,
      undefined,
      undefined,
      undefined,
      getAxiosConfig(cancelToken)
    )
  ).then(handleResponse);

export default {
  getInteractiveForms,
  getInteractiveFormStates,
};
